import { PACKAGE_MODULE_NAME_TO_PLAN_KEY, planKeyFromPackageModuleName } from './planModuleAccess'
import { userMatchesRoleAccess } from './userRole'

/** Sidebar mapModule keys in Aside.jsx — module_name from API → display token */
export const SIDEBAR_MODULE_MAP = {
  userManagment: 'User Management',
  products: 'Products',
  warehouse: 'WareHouse',
  vendor: 'Vendor',
  stock_receipt: 'Stock Receipt',
  stock_transfer: 'Stock Transfer',
  adjustment: 'Adjustment',
  customer: 'Costumers',
  sales: 'Sales',
  expensive: 'Expensive',
  configuration: 'Configuration',
  Reports: 'Reports',
  reports: 'Reports',
  pos: 'pos',
  purchase_order: 'Purchase Order',
}

export { PACKAGE_MODULE_NAME_TO_PLAN_KEY }

function normalizeModuleName(moduleName) {
  return String(moduleName || '').trim()
}

/** @returns {string[]} tokens used by Aside allowedModulesArray.includes('Reports'|'pos'|...) */
export function buildAllowedSidebarModules(userInfo) {
  const allowed = new Set()
  const modules = userInfo?.company?.package?.module_in_package || []
  modules.forEach((module) => {
    const name = normalizeModuleName(module?.module_name)
    const mapped = SIDEBAR_MODULE_MAP[name]
    if (mapped) allowed.add(mapped)
    const planKey = planKeyFromPackageModuleName(name)
    if (planKey === 'stock_transfers') allowed.add('Stock Transfer')
  })
  return Array.from(allowed)
}

export function sidebarIncludesModule(allowedModulesArray, token) {
  return allowedModulesArray.includes(token)
}

export function companyHasPosAccess(userInfo) {
  return sidebarIncludesModule(buildAllowedSidebarModules(userInfo), 'pos')
}

/** User Management in sidebar — company app administrators only (`roles[].name === admin`). */
export function canShowUserManagementNav(userInfo) {
  return userMatchesRoleAccess(userInfo, { allow: ['admin'] })
}
